import React, { FC, useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Settings from 'client/blocks/Settings/Settings';
import { SettingsPageContext } from 'client/context/settingsPageContext';
import { routes } from 'client/lib/routes';
import { InstallableApp } from 'client/model/skill';
import { getCanEditApp, getInstallableAppSettingsEntity } from 'client/utils';

import { FeatureFlags } from '../FeatureFlags/FeatureFlags';

interface Props {
    installableApp: InstallableApp;
    setInstallableApp: (app: InstallableApp) => void;
}

export const InstallableAppSettingsPage: FC<Props> = ({ installableApp, setInstallableApp }) => {
    const { isDraft, hasUnsavedChanges, setHasUnsavedChanges } = useContext(SettingsPageContext);

    const disabled = !getCanEditApp(installableApp);

    return (
        <div>
            <article>
                <Routes>
                    <Route path="feature-flags" element={<FeatureFlags />} />
                    <Route
                        path="main"
                        element={
                            !isDraft && !installableApp.onAir ? (
                                <Navigate
                                    to={routes.app.installableAppSettings(
                                        installableApp.channel,
                                        true,
                                        'main',
                                        installableApp.id,
                                    )}
                                    replace
                                />
                            ) : (
                                <Settings
                                    aliceApp={installableApp}
                                    setInstallableApp={setInstallableApp}
                                    isDraft={!!isDraft}
                                    registerChanges={setHasUnsavedChanges || ((_) => {})}
                                    hasChanges={!!hasUnsavedChanges}
                                    settings={getInstallableAppSettingsEntity(installableApp, !!isDraft)}
                                    disabled={disabled}
                                />
                            )
                        }
                    />
                    <Route path="*" element={<Navigate to="../main" replace />} />
                </Routes>
            </article>
        </div>
    );
};
